<template>
<div class="chapter">
<div class="inner_page">
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="center"><a id="pvii"></a> <em>for</em> B.A.—</p>
<p class="center">Plan A</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?36ac0cca